import templateUrl from './settings.component.html';

export default {
	templateUrl
};
